/**
 * Focus the first data row in an antd Table inside a panel (by panel element id).
 */
export function focusFirstTableDataRow(panelId) {
  if (!panelId) {
    return;
  }
  const panel = document.getElementById(panelId);
  if (!panel) {
    return;
  }
  const row = panel.querySelector('tbody tr[data-row-key]')
    || panel.querySelector('table tbody tr');
  if (!row) {
    return;
  }
  if (row.getAttribute('tabindex') === null) {
    row.setAttribute('tabindex', '0');
  }
  if (typeof row.focus === 'function') {
    row.focus();
  }
}
